import { Route } from '../Routing/types';
import { AVAILABLE_MEASUREMENTS } from './consts';
import { PATH_MEASUREMENT, PATH_MEASUREMENT_ADD, PATH_MEASUREMENT_EDIT } from './paths';
import {
  MeasurementsIndexPage,
  AddMeasurementPage,
  EditMeasurementPage,
} from '@front-activerse/modules';

const dummy_t = (translationKey: string) => translationKey;

const descendantRoutes: Route[] = [
  {
    path: PATH_MEASUREMENT,
    element: (
      <MeasurementsIndexPage
        availableMeasurements={AVAILABLE_MEASUREMENTS}
        paths={{ PATH_MEASUREMENT_ADD, PATH_MEASUREMENT_EDIT }}
      />
    ),
    private: true,
    title: dummy_t('measurements.navbarTitle'),
    mobileAppTabIdentifier: '',
  },
  {
    path: PATH_MEASUREMENT_ADD,
    element: <AddMeasurementPage availableMeasurements={AVAILABLE_MEASUREMENTS} />,
    private: true,
    title: dummy_t('addMeasurements.navbarTitle'),
    mobileAppTabIdentifier: '',
  },
  {
    path: PATH_MEASUREMENT_EDIT,
    element: <EditMeasurementPage availableMeasurements={AVAILABLE_MEASUREMENTS} />,
    private: true,
    title: dummy_t('editMeasurements.navbarTitle'),
    mobileAppTabIdentifier: '',
  },
];

export default descendantRoutes;
